export const locale = {
  lang: 'tr',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'Benim profilim',
      'ENLACES': {
        'configuracion': 'Hesap ayarları',
        'notificaciones': 'Kullanıcı bildirimleri',
        'mensajes': 'alınan mesajlar'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Hesap ayarları',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'Değişim e-posta',
              'SUBTITULO': 'Hesabınızın e-posta adresini değiştirebilirsiniz',
              'INPUTS': {
                'MAIL': 'yeni e-posta adresi',
                'TOKEN': 'Doğrulama kodu',
                'PASS': 'Yeni Şifre',
                'CONFIRMPASS': 'Şifreyi Onayla'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'Değişim e-posta',
                'VERTOKEN': 'Kodu kontrol et',
                'FINALMAIL': 'e-posta adresini değiştir',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Şifre değiştir',
              'SUBTITULO': 'Hesap şifrenizi değiştirebilirsiniz',
              'BOTONES': {
                'FINALPASS': 'Şifre değiştir'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'İki adımlı kimlik doğrulama',
              'SUBTITULO': 'İki adımlı kimlik doğrulamayı etkinleştirerek hesabınızın güvenliğini artırabilirsiniz.',
              'BOTONES': {
                'ACTIVAR': 'etkinleştir',
                'DESACTIVAR': 'Devre dışı bırakmak'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'Belirtilen e-postaya doğrulama kodu içeren bir mesaj gönderildi, işleme devam etmek için alınan doğrulama kodunu girin',
        'CAMBIARMAIL_PASO1_NOTOK': 'Devam edilemiyor, girilen e-posta sistemde zaten kayıtlı',
        'CAMBIARMAIL_PASO1_SAME': 'Devam edilemiyor, girilen e-posta adresi şu anda hesapta bulunan ile aynı',
        'CAMBIARMAIL_PASO2_OK': 'Doğrulama kodu doğru, devam etmek için aşağıya yeni bir şifre girmeniz gerekiyor',
        'CAMBIARMAIL_PASO2_NOTOK': 'Doğrulama kodu yanlış, lütfen doğru girdiğinizi kontrol edin ve tekrar kontrol edin.',
        'CAMBIARMAIL_PASO3_NOTOK': 'Devam edilemiyor, şifreler eşleşmiyor, lütfen doğru şekilde tekrar girin',
        'CAMBIARMAIL_PASO3_OK': 'Hesap verileri doğru bir şekilde güncellendi, işlemi tamamlamak için oturum kapatılacak, yeni erişim verilerini kullanarak platforma tekrar girin',
        'CAMBIAPASS_OK': 'Hesap şifresi başarıyla güncellendi',
        'CAMBIAPASS_NOTOK': 'Devam edilemiyor, şifreler eşleşmiyor, lütfen doğru şekilde tekrar girin',
        'AUTHOK': 'Kimlik doğrulama durumu başarıyla güncellendi'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Kapat      ',
      'MYPROFILLE':'Benim profilim',
      'TITLE':'Şifre değiştir',
       'BTNBACK':'Geri',
       'MENUTITLE':'Menü',
       'MENU':{
         'OPC1':'Benim verim'
       },
       'NAME':'İsim',
       'EMAIL':'Eposta',
       'CODE':'Verification code',
       'NEWPASS':'New Password',
       'REPASS':'Şifrenizi yeniden yazın',
       'CHANGE':'Şifre değiştir',
       'SENDCODE':'Doğrulama kodu Gönder',
       'CHECKCODE':'Doğrulama kodu',
       'ERROR':{
        'ERROR01':'Gerekli alan',
        'ERROR02':'Hata, bir şey oldu',
        'ERROR03':'Kod eşleşmiyor',
        'ERROR04':'Parolalar uyuşmuyor',
        'ERROR05':'En az 3 karakter olmalıdır',
        'ERROR06':'O e-mail já existe, tente com outro',
        'ERROR07':"Şirket adı 'eşleşmiyor"
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'Veriler doğru şekilde güncellendi',
       'MESESAGE2':'Kod gönderildi ... Lütfen e-postanızı kontrol edin',
       'MESESAGE3':'Doğru kod'
      }

    },
  }
};
